import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatGridListModule } from '@angular/material/grid-list'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { QualyTableComponent } from "./season-metrics/components/qualy-table/qualy-table.component";
import { VideosComponent } from "./youtube/youtube.component"
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { ArticlesCard } from './news/components/articles/components/articles-card/articles-card.component'
import { Article, Rumour } from '../core/models/rumour.model'
import { NewsService } from './news/services/news.service'
import { RumoresCard } from './news/components/rumores/components/rumores-card/rumores-card.component'
import { MiniCalendarComponent } from './season-metrics/components/calendar/minicalendar.component'
import { RecentNewsComponent } from './news/components/recent-news/recent-news.component'
import { MatTableModule } from '@angular/material/table'
import { MatCardModule } from '@angular/material/card'
import { Meta, Title } from '@angular/platform-browser'
import { Match } from '../core/models/match.model'
import { MatchService } from '../core/services/matches.service'
import { MatchResultComponent } from "./matches/components/match-result/match-result.component";

@Component({
    selector: 'home-component',
    templateUrl: 'home.component.html',
    standalone: true,
    imports: [
    MatGridListModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    QualyTableComponent,
    MatButtonModule,
    MiniCalendarComponent,
    MatDividerModule,
    ArticlesCard,
    VideosComponent,
    RumoresCard,
    MatTableModule,
    MatCardModule,
    RecentNewsComponent,
    MatchResultComponent
],
    styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit{
    articles: Article[] = []
    rumores: Rumour[] = []
    recentMatch: Match | undefined = undefined
    isMobile: boolean = false
    upgrades: {date:Date, upgrade:string}[] = []
    favSections = [
        {name: 'Creador de alineaciones', shortName: 'Lineup', link: '/lineup'},
        {name: 'Base de datos', shortName: 'BDD', link: '/db'},
        {name: 'Artículos', shortName: 'Artículos', link: '/news'},
        {name: 'Rumores', shortName: 'Rumores', link: '/news/rumores'}
    ]

    constructor(
        private service: NewsService,
        private matchService: MatchService,
        private title: Title,
        private meta: Meta
    ){}

    ngOnInit() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
          //console.warn('renderImage called in SSR, skipping')
          return
        }
        this.clearMetaTags()
        this.title.setTitle('Atlético Stats')
        // 🔹 Descripción general (recomendada)
        const description = 'Atlético Stats: tu portal de información estadística del Atlético de Madrid. Somos fútbol, periodismo y datos, pero sobre todo Atleti.'
        this.meta.addTag({ name: 'description', content: description }, true);

        // 🔹 Open Graph (usado por WhatsApp, Facebook, LinkedIn...)
        this.meta.addTag({ property: 'og:title', content: 'Atlético Stats' }, true);
        this.meta.addTag({ property: 'og:description', content: description }, true);
        this.meta.addTag({ property: 'og:image', content: 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/LogoPortada.png' }, true);
        this.meta.addTag({ property: 'og:url', content: 'atleticostats.com' }, true);
        this.meta.addTag({ property: 'og:type', content: 'website' }, true);
        this.meta.addTag({ property: 'og:site_name', content: 'Atlético Stats' }, true);

        // 🔹 Twitter Card (mejor compatibilidad con Twitter)
        this.meta.addTag({ name: 'twitter:card', content: 'summary_large_image' }, true);
        this.meta.addTag({ name: 'twitter:title', content: 'Atlético Stats' }, true);
        this.meta.addTag({ name: 'twitter:description', content: description }, true);
        this.meta.addTag({ name: 'twitter:image', content: 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/LogoPortada.png' }, true);

        this.service.fetchArticles()
        .subscribe(val=>{
            this.articles = (val as Article[])
            .filter(a=>a.state=='Publicado')
            .sort((a, b) => new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime())
            .slice(0, 3)
        })

        this.service.fetchRumours()
        .subscribe(val=>{
            this.rumores = (val as Rumour[])
            .filter(r=>r.type=='FICHAJE' && r.category=='General')
            .sort((a, b) => {
                const dateA = this.service.getMostRecentDate(a.news)
                const dateB = this.service.getMostRecentDate(b.news)
                return dateB - dateA
            })
            .slice(0, 6)
        })

        this.service.fetchUpgrades()
        .subscribe(val=>{
            this.upgrades = (val as {date:Date, upgrade:string}[])
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .slice(0, 6)
        })

        this.matchService.getMostRecentMatch()
        .subscribe(val=>{
            this.recentMatch = val as Match
        })

        this.checkScreenSize()
        window.addEventListener('resize', this.checkScreenSize.bind(this))
    }

    checkScreenSize() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        this.isMobile = window.innerWidth < 900
    }

    ngOnDestroy() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        this.clearMetaTags()
        window.removeEventListener('resize', this.checkScreenSize.bind(this))
    }

    clearMetaTags() {
    const metaTags = [
      'description',
      'twitter:card',
      'twitter:title',
      'twitter:description',
      'twitter:image',
      'og:title',
      'og:description',
      'og:image',
      'og:url',
      'og:type',
      'og:site_name'
    ]

    metaTags.forEach(nameOrProperty => {
      this.meta.removeTag(`name='${nameOrProperty}'`)
      this.meta.removeTag(`property='${nameOrProperty}'`)
    })
  }
}